export default __webpack_public_path__ + "static/venn-diagram-mobile-8896052050b3e3dc9227b989bdc93adf.svg";